module.exports = __webpack_public_path__ + "static/media/CV_Maxime_Poulain.1c85a9c6.pdf";